module.exports = __webpack_public_path__ + "static/img/mk73p.96b00d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/mk73p.jpg
// module id = Dera
// module chunks = 0